import React from 'react'

import { IconProps, SIconSpan } from '../../../common/styles/Icons'

const SearchIcon = ({ fill = 'currentColor', size = 14, title, id = 'search-icon' }: IconProps): React.ReactElement => {
    return (
        <SIconSpan title={title} id={id} size={size}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke={fill}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
        </SIconSpan>
    )
}

export default SearchIcon
